import styled from '@emotion/styled'

import { useArcadeMigrationFeatureFlag } from '../ArcadeComponentMigration/ArcadeComponentMigrationProvider'

/**
 * `PaddingInset` Component
 * *
 * @overview
 * The `PaddingInset` component is a layout utility to provide a fixed padding inset.
 *
 * @deprecated Do not use
 */
const Padding = styled.div<{ shouldAddPadding?: boolean }>`
  padding: ${props => (props.shouldAddPadding ? `0 ${props.theme.spacing.xs}` : '0')};
`

const PaddingInset = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const shouldIncludePadding = !useArcadeMigrationFeatureFlag('padding-inset')

  return <Padding shouldAddPadding={shouldIncludePadding} {...props} />
}

export default PaddingInset
